import type { WeaponModel } from '../types';

export type { WeaponModel };

export const WOODEN_CLUB_TEXTURE = 'wooden-club';
export const HAND_WHITE_TEXTURE = 'hand-white';

export const DEFAULT_WEAPON_TUNING = {
  windDegFarExtra: 48,
  followDeg: 10,
  swingInMs: 55,
  swingOutMs: 70,
  fadeMs: 90,
  startOffscreenRatio: 0.55,
  farStartPush: 0.65,
  clubSrcW: 277,
  clubSrcH: 713,
  clubOriginX: 0.5,
  clubOriginY: 0.94,
  hitEdgeInsetRatio: 0.06,
  idleHoverY: 12,
  idleHoverAngle: 2.5,
  idleHoverDurationMs: 2400,
  idleReturnMs: 110,
  /** Per-swing timing wobble (0.12 = ±12%). */
  swingSpeedJitter: 0.12,
  /** Fraction of club width visible at idle (0.7 = 70% on screen). */
  idleVisibleFraction: 0.7,
  /** Inset from visible crop edges when placing idle club. */
  idleVisiblePadding: 24,
} as const;

export function clubDisplaySize(model: WeaponModel) {
  const h = model.displayHeight;
  const w = (DEFAULT_WEAPON_TUNING.clubSrcW / DEFAULT_WEAPON_TUNING.clubSrcH) * h;
  return { width: w, height: h };
}
